const getResizedCanvas = (canvas, pictureMaxWidth, pictureRatio) => {
  const tmpCanvas = document.createElement("canvas");
  const height = pictureMaxWidth * pictureRatio;
  tmpCanvas.width = pictureMaxWidth;
  tmpCanvas.height = height;

  const context = tmpCanvas.getContext("2d");
  context.drawImage(
    canvas,
    0,
    0,
    canvas.width,
    canvas.height,
    0,
    0,
    pictureMaxWidth,
    height
  );

  return tmpCanvas;
};

export const getChoosenImage = (file, callback) => {
  if (file && file.type !== "image/svg+xml") {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.addEventListener("load", callback);
  }
};

export const onImageChanged = (
  canvas,
  pictureMaxWidth,
  pictureRatio,
  callback
) => {
  canvas.width > pictureMaxWidth
    ? getResizedCanvas(canvas, pictureMaxWidth, pictureRatio).toBlob(
        callback,
        "image/jpeg"
      )
    : canvas.toBlob(callback, "image/jpeg");
};
